import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { NotificationAccordionControllerGetByIdParameter } from '../parameters/notification-accordion-controller-get-by-id.parameter';
import { NotificationAccordionControllerGetByIdResponse } from '../responses/notification-accordion-controller-get-by-id.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'service-shared-features',
    operationId: 'NotificationAccordionController_getById',
    operation: '{"operationId":"NotificationAccordionController_getById","parameters":[{"name":"uuid","required":true,"in":"path","schema":{"type":"string"}}],"responses":{"200":{"content":{"application/json":{"schema":{"type":"object","properties":{"uuid":{"type":"string"},"name":{"type":"string"}},"required":["uuid","name"]}}}}},"method":"get","path":"/notification-accordion/{uuid}"}'
  })
export class NotificationAccordionControllerGetByIdRemoteMethod extends OpenApiRemoteMethod<NotificationAccordionControllerGetByIdResponse, NotificationAccordionControllerGetByIdParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<NotificationAccordionControllerGetByIdParameter, void>): Promise<NotificationAccordionControllerGetByIdResponse> {
    return super.call(parameters);
  }
}
